<template>
  <div class="red-packet1-dialog">
    <div class="red-packet1-content" slot="custom">
      <div class="container-table">
        <span class="amount">
          {{data.discountValue}}
        </span>
        <span class="unit">
          现金红包
        </span>
      </div>
      <nd-button class="withdraw" @click="handleButtonClick" 
                 v-stat="{
                   id: 50022,
                   args: {
                     target: 'NEW_PERSON', // 新人活动
                     step: data.nextStep,
                     position: 2,
                     status: 1
                   },
                 }"
      >惊喜提现</nd-button>
      <div class="activity-detail">
        激活有效期：{{ data.activeEndTime | date('YYYY/MM/DD') }}前
      </div>
    </div>
  </div>
</template>
<script>
import { setKey } from '@/assets/utils'

export default {
  data () {
    return {
      visible: true
    }
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    open () {
      this.visible = true
      setKey('NEW_COMER_2_SHOW_TIME', Date.now())
    },
    close () {
      this.visible = false
      this.$emit('close')
    },
    handleButtonClick () {
      // this.$report({
      //     id: 10124,
      //     args: {
      //         target: 3,
      //         status: this.data.couponDetailType
      //     }
      // })
      if (this.data.nextStep === 'LOAN') {
        return this.$router.push({
          path: '/withdraw/index'
        })
      } 
      if (this.data.nextStep === 'INFO' || this.data.nextStep === 'CREDIT') {
        return this.$router.push({
          path: '/authentication/base'
        })
      }
    },
    show () {
      setKey('NEW_COMER_2_SHOW_TIME', Date.now())
      this.$report({
        id: 50021,
        args: {
          visible: 1,
          target: 'NEW_PERSON', // 免息活动
          step: this.data.nextStep,
          status: 1
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
@import "../../../../assets/less/mixin.less";

.red-packet1-dialog {
    .red-packet1-content {
        width: 620px;
        height: 750px;
        border-radius: 30px;
        position: relative;
        background: url('./pop_xinyinghu02@2x.png');
        background-size: 100%;
        .activity-detail {
            position: absolute;
            bottom: 0px;
            left: 0px;
            right: 0px;
            text-align: center;
            font-size: 28px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(255, 255, 255, 1);
            margin-bottom: 53px;
        }
        .container-table{
            margin:auto;
            display: flex;
            flex-direction: column;
            justify-content:space-between;
            align-items: center;
            width:250px;
            height:114px;
            padding-top:240px;
            .amount{
                height: 73px;
                font-size: 60px;
                font-family: DIN-Medium, DIN;
                font-weight: 500;
                color: #FF4633;
                line-height: 73px;
            }
            .unit{
                height: 40px;
                font-size: 28px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #FF4633;
                line-height: 40px;
            }
        }
        .withdraw {
            position: absolute;
            display: flex;
            justify-content: space-around;
            top: 540px;
            width: 440px;
            height: 80px;
            left: 50%;
            transform: translateX(-50%);
            font-size: 36px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #FFFFFF;
            line-height: 50px;
        }
    }
}
</style>
